/**
 * List components can be composed together to create a
 * List UI, which we use throughout the application.
 */
import List from './List';
import ListHeader from './ListHeader';
import ListSidebarHeader from './ListSidebarHeader';
import ListHeaderText from './ListHeaderText';
import ListBody from './ListBody';
import ListRow from './ListRow';
import ListRowLoading from './ListRowLoading';
import ListRowTitle from './ListRowTitle';
import ListRowSubtitle from './ListRowSubtitle';
import ListRowDetails from './ListRowDetails';
import ListRowDetailsItem, { IconBadgeListRowDetailsItem } from './ListRowDetailsItem';
import ListRowDetailsItemBadge from './ListRowDetailsItemBadge';
import './List.less';
import ListRowContainer from './ListRowContainer';

type BaseListType = typeof List & {
  Header: typeof ListHeader;
  SidebarHeader: typeof ListSidebarHeader;
  HeaderText: typeof ListHeaderText;
  Body: typeof ListBody;
  Row: typeof ListRow;
  RowContainer: typeof ListRowContainer;
  RowLoading: typeof ListRowLoading;
  RowTitle: typeof ListRowTitle;
  RowSubtitle: typeof ListRowSubtitle;
  RowDetails: typeof ListRowDetails;
  RowDetailsItem: typeof ListRowDetailsItem;
  RowDetailsIconItem: typeof IconBadgeListRowDetailsItem;
  RowDetailsIconItemBadge: typeof ListRowDetailsItemBadge;
};

const BaseList: BaseListType = List;
BaseList.Header = ListHeader;
BaseList.SidebarHeader = ListSidebarHeader;
BaseList.HeaderText = ListHeaderText;
BaseList.Body = ListBody;
BaseList.Row = ListRow;
BaseList.RowContainer = ListRowContainer;
BaseList.RowLoading = ListRowLoading;
BaseList.RowTitle = ListRowTitle;
BaseList.RowSubtitle = ListRowSubtitle;
BaseList.RowDetails = ListRowDetails;
BaseList.RowDetailsItem = ListRowDetailsItem;
BaseList.RowDetailsIconItem = IconBadgeListRowDetailsItem;
BaseList.RowDetailsIconItemBadge = ListRowDetailsItemBadge;

export default BaseList;
